import { Resource } from './resource';
import { Filter } from './filters';
import { Sort } from './sort';
import { Organization } from './api';

export enum HomeTabs {
  DPU_SEARCH = 'DPU_SEARCH',
  ORGANIZATIONS = 'ORGANIZATIONS',
}

export type HomeState = {
  filters: Array<Filter>;
  searchText: string;
  sort: Sort;

  organizationResource: Resource<{
    organizations: Array<Organization>;
  }>;

  dpuResource: Resource<{
    units: Array<{
      id: string;
      name: string;
      hrefId: string;
      organizationId: Organization['id'];
      organizationName: Organization['name'];
    }>;
  }>;

  activeTab: HomeTabs;
  search: string;
};

export enum HomeActionTypes {
  HOME_CHANGE_PAGE = 'HOME_CHANGE_PAGE',

  HOME_LOAD_DPUS_START = 'HOME_LOAD_DPUS_START',
  HOME_LOAD_DPUS_COMPLETE = 'HOME_LOAD_DPUS_COMPLETE',
  HOME_LOAD_DPUS_ERROR = 'HOME_LOAD_DPUS_ERROR',

  HOME_LOAD_ORGANIZATIONS_START = 'HOME_LOAD_ORGANIZATIONS_START',
  HOME_LOAD_ORGANIZATIONS_COMPLETE = 'HOME_LOAD_ORGANIZATIONS_COMPLETE',
  HOME_LOAD_ORGANIZATIONS_ERROR = 'HOME_LOAD_ORGANIZATIONS_ERROR',

  HOME_CHANGE_TAB = 'HOME_CHANGE_TAB',
  HOME_CHANGE_SEARCH = 'HOME_CHANGE_SEARCH',
}

export type HomeAction =
  | { type: HomeActionTypes.HOME_CHANGE_PAGE }
  | { type: HomeActionTypes.HOME_LOAD_ORGANIZATIONS_START }
  | { type: HomeActionTypes.HOME_LOAD_ORGANIZATIONS_ERROR; error: any }
  | {
      type: HomeActionTypes.HOME_LOAD_ORGANIZATIONS_COMPLETE;
      organizations: Array<Organization>;
    }
  | { type: HomeActionTypes.HOME_LOAD_DPUS_START }
  | { type: HomeActionTypes.HOME_LOAD_DPUS_ERROR; error: any }
  | {
      type: HomeActionTypes.HOME_LOAD_DPUS_COMPLETE;
      dpus: Array<{
        id: string;
        name: string;
        organizationId: string;
        organizationName: string;
        hrefId: string;
      }>;
    }
  | { type: HomeActionTypes.HOME_CHANGE_TAB; tab: HomeTabs }
  | { type: HomeActionTypes.HOME_CHANGE_SEARCH; search: string };
